module.exports = __webpack_public_path__ + "static/img/cont56 (3).7c95ed5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont56 (3).jpg
// module id = 5rr6
// module chunks = 0